import { createI18n } from 'vue-i18n'
import zhTW from './zh-TW'
import zhCN from './zh-CN'
import enUS from './en-US'

// 支持的语言列表
export const LANGUAGES = {
  'zh-TW': '繁體中文',
  'zh-CN': '简体中文',
  'en-US': 'English'
}

const getDefaultLanguage = () => {
  const saved = localStorage.getItem('language')
  if (saved && ['zh-TW', 'zh-CN', 'en-US'].includes(saved)) return saved
  return 'zh-TW'
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getDefaultLanguage(),
  fallbackLocale: false,        // 关闭自动 fallback，避免 zh-TW 降级成 zh
  missingWarn: false,           // 关闭 missing key 警告
  fallbackWarn: false,          // 关闭 fallback 警告
  warnHtmlMessage: false,
  messages: {
    'zh-TW': zhTW,
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

export default i18n
